import React, { useState } from 'react';
import { 
  Box, 
  Container, 
  Tab, 
  TabList, 
  TabPanel, 
  TabPanels, 
  Tabs,
  Spinner,
  Center,
  VStack,
  Text
} from '@chakra-ui/react';
import ClientManagement from '../components/ClientManagement';
import DailySchedule from '../components/DailySchedule';
import ReceptionistClientList from '../components/ReceptionistClientList'; // Add this import
import ReceptionistRequestsOthers from '../components/ReceptionistRequestsOthers';

const LoadingOverlay = () => (
  <Center height="100%" width="100%">
    <VStack spacing={4}>
      <Spinner 
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.500"
        size="xl"
      />
      <Text color="gray.500">Loading...</Text>
    </VStack>
  </Center>
);

const ReceptionistDashboard = () => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTabIndex(index);
  };

  return (
    <Container maxW="1200px" py={8}>
      <Tabs 
        isFitted 
        variant="enclosed" 
        index={selectedTabIndex} 
        onChange={handleTabChange}
      >
        <TabList mb="1em">
          <Tab>Daily Schedule</Tab>
          <Tab>Client List</Tab> {/* Add this tab */}
          <Tab>Requests & Others</Tab>
          {/*<Tab>Client Management</Tab>*/}
        </TabList>

        <TabPanels>
          <TabPanel position="relative" minHeight="500px">
            <DailySchedule 
              key={`daily-schedule-${selectedTabIndex}`}
            />
          </TabPanel>
          
          {/* Add this new TabPanel */}
          <TabPanel position="relative" minHeight="500px">
            <ReceptionistClientList 
              key={`client-list-${selectedTabIndex}`}
              LoadingComponent={LoadingOverlay}
            />
          </TabPanel>
          
          {/* Requests & Others TabPanel */}
          <TabPanel position="relative" minHeight="500px">
            <ReceptionistRequestsOthers 
              key={`requests-others-${selectedTabIndex}`}
              LoadingComponent={LoadingOverlay}
            />
          </TabPanel>
          
          {/*}
          <TabPanel position="relative" minHeight="500px">
            <ClientManagement 
              key={`client-management-${selectedTabIndex}`}
              LoadingComponent={LoadingOverlay}
            />
          </TabPanel>
          */}
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default ReceptionistDashboard;